import { apiFetch } from '@newtontechnologies/beey-api-js-client/apilib';
import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
import { json } from '@newtontechnologies/beey-api-js-client/receivers';
export const fetchProviders = async () => apiFetch()
    .url(apiV2.providers.url())
    .receive(json()
    .map((data) => data.providers))
    .fetch();
export const fetchProviderByName = async (connection, providerKey) => connection.fetch()
    .url(apiV2.auth.providerByName.url({ key: providerKey }))
    .receive(json())
    .fetch();
